// /src/data/books/FundamentosBlockchain/data/cap1.js

const CAP1 = {
  id: 1,
  slug: "cap1-introduccion-blockchain",
  title: "Capítulo 1 — Bienvenida a la tecnología blockchain",
  sections: [
    {
      heading: "Bienvenida",
      text: [
        "¡Bienvenid@ a este recorrido por la tecnología blockchain!",
        "Estás a punto de adentrarte en una de las herramientas digitales más influyentes de nuestra época. A lo largo de este libro verás cómo la blockchain está cambiando la forma en que entendemos el dinero, los registros, los contratos y, en general, la confianza en el mundo digital."
      ]
    },
    {
      heading: "¿Por qué hablar de blockchain hoy?",
      text: [
        "Cada vez más sectores incorporan blockchain en su día a día: finanzas, logística, certificados, identidad digital, arte, videojuegos y muchos más.",
        "Detrás de todas esas aplicaciones hay una misma idea central: **crear sistemas donde los datos puedan verificarse sin depender por completo de una única entidad de confianza**.",
        "Entender esta base te permitirá ir más allá de la moda de las criptomonedas y ver la tecnología con ojos críticos y propios."
      ]
    },
    {
      heading: "Pensado para empezar desde cero",
      text: [
        "Este material está diseñado para personas que **empiezan desde cero**, sin necesidad de conocimientos previos en programación, criptografía o economía.",
        "A lo largo de los capítulos iremos introduciendo los conceptos poco a poco, usando ejemplos cotidianos y comparaciones sencillas, para que el tema sea accesible sin perder profundidad."
      ]
    },
    {
      heading: "Qué veremos en este libro",
      list: [
        "Qué es una blockchain y por qué es distinta a una base de datos tradicional.",
        "Cómo se organizan los bloques, las transacciones y la red que los valida.",
        "Qué papel juegan las claves públicas y privadas en la custodia de valor digital.",
        "Cuáles son las aplicaciones más comunes: pagos, tokens, NFT, identidad, contratos inteligentes.",
        "Qué riesgos existen, cuáles son los errores más frecuentes y cómo evitarlos."
      ]
    },
    {
      heading: "Más que teoría: criterio para el mundo real",
      text: [
        "Aunque encontrarás definiciones y explicaciones técnicas, el objetivo principal no es que memorices conceptos, sino que desarrolles **criterio**.",
        "Al terminar el libro deberías sentirte capaz de:",
        "- Entender de qué hablan cuando se menciona blockchain en noticias o proyectos.",
        "- Evaluar con más calma si una propuesta tiene sentido o solo es marketing.",
        "- Tomar decisiones más informadas al interactuar con criptomonedas y aplicaciones descentralizadas."
      ]
    },
    {
      heading: "Cómo aprovechar mejor los capítulos",
      text: [
        "La recomendación es avanzar en orden, ya que los conceptos se van construyendo unos sobre otros. Puedes leer de corrido primero y después volver a los capítulos clave para repasar.",
        "Encontrarás ejemplos, analogías y pequeñas tareas o preguntas de reflexión que te ayudarán a aterrizar lo aprendido a tu propia realidad.",
        "No te preocupes si algo no se entiende a la primera: blockchain es un tema denso, pero con paciencia y curiosidad se vuelve mucho más claro."
      ]
    },
    {
      heading: "Punto de partida",
      text: [
        "Con esta bienvenida, damos inicio al viaje. En los siguientes capítulos empezaremos por lo esencial: qué problema intenta resolver la blockchain, cómo se construye una red distribuida y por qué todo el mundo habla de bloques, hashes y consenso.",
        "Tómate tu tiempo, marca lo que te llame la atención y, sobre todo, mantén una actitud de duda sana: en el mundo cripto, hacer buenas preguntas es tan importante como encontrar buenas respuestas."
      ]
    }
  ]
};

export default CAP1;
